import { withStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

const styled = withStyles(theme => {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
    },
    grow: {
      flexGrow: 1
    },

    noFocus: {
      outline: 'none',
    },
    navButton: {
      marginLeft: 10,
    },
    menu: {
      minWidth: 170,
    },
    leftIcon: {
      marginRight: theme.spacing.unit
    },
    rightIcon: {
      marginLeft: theme.spacing.unit
    },
    logoContainer: {
      ...theme.mixins.toolbar,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    logo: {
      width: 120,
    },
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      marginLeft: drawerWidth,
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
      },
    },
    menuButton: {
      marginRight: 20,
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    toolbarPadding: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        maxWidth: `calc(100% - ${drawerWidth}px)`,
      },
    },
  };
});

export default styled;
